import { useWorkspaceContext } from "src/router/routerContextHooks";

// Agent Builder enablement lives on the agents module config
// `feature_flag_tktl_agents` boolean: a deployed agents module reads as
// enabled unless the flag is explicitly `false`, mirroring the backend
// `module_service.is_tktl_agents_enabled`.
export const useIsAgentsBuilderFeatureEnabled = (): {
  isEnabled: boolean;
} => {
  const { modules } = useWorkspaceContext();

  const agentsModule = modules?.find(
    (m) => m.kind === "agents" && m.spec !== null,
  );
  const agentsFlag = agentsModule?.desiredSpec.config
    .feature_flag_tktl_agents as boolean | undefined;

  return { isEnabled: agentsModule !== undefined && (agentsFlag ?? true) };
};
